<template>
  <v-card
    class="mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo số lượng KH, tỉ lệ chốt, doanh thu theo nguồn
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div class="px-5">
      <v-row>
        <v-col cols="12" md="6" class="py-0">
          <v-select
            v-model="groupId"
            :items="group"
            item-text="name"
            item-value="id"
            label="Nhóm sản phẩm"
            placeholder="Nhóm sản phẩm"
            color="primary"
            :value="groupId"
          />
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select
            v-model="storedId"
            :items="store"
            item-text="text"
            item-value="value"
            label="Chọn kho"
            placeholder="Chọn kho"
            color="primary"
            :value="storedId"
          />
        </v-col>

        <v-col cols="12" class="text-center">
          <v-btn
            class="primary mx-0"
            @click="search"
          >
            <v-icon>mdi-magnify</v-icon>Tìm kiếm
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <SourceReportTable
      :data="data"
    />

  </v-card>
</template>

<script>

import * as moment from 'moment'

import RepositoryFactory from "@/repositories/RepositoryFactory";
import SourceReportTable from './SourceReportTable'

const ReportRepository = RepositoryFactory.get('report');
const ProductRepository = RepositoryFactory.get('product_group');

export default {
  components: {SourceReportTable},
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      data: [],
      chartOptions: {
        height: 300,
      },
      storedId: 0,
      groupId: 0,
      store: [
        {
          text: 'Tất cả',
          value: 0
        },
        {
          text: 'Kho T',
          value: 2
        },
        {
          text: 'Kho C',
          value: 1
        },
        // {
        //   text: 'Kho G',
        //   value: 3
        // }
      ],
      group: []
    }
  },
  created() {
    Bus.$on('source-report-thpt', () => {
      this.fetchData()
    })
    this.getProductGroupList()
    this.fetchData()
  },
  beforeDestroy() {
    Bus.$off('source-report-thpt')
  },
  methods: {
    search() {
      this.fetchData()
    },
    async fetchData() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        storedId: this.storedId,
        groupId: this.groupId,
        schoolLevelIds: [2]
      };
      const result = await ReportRepository.fetchSource(params)
      loader.hide()
      if (result.success) {
        this.data = _.get(result, 'data', [])
      }
    },
    async getProductGroupList() {
      const loader = this.$loading.show()
      const params = {
        limit: 1000
      };
      const result = await ProductRepository.list(params)

      this.group = [{
        id: 0,
        name: 'Tất cả'
      }]

      if (result.success) {
        this.group.push( ..._.get(result, 'data', []) )
      }
      loader.hide()
    }
  },
}
</script>
